var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "box view-nav-bar" },
      [
        _c("b-form-input", {
          staticClass: "transparent-input",
          attrs: {
            type: "search",
            debounce: "400",
            placeholder: "Movie title or Movix ID",
          },
          model: {
            value: _vm.searchTerm,
            callback: function ($$v) {
              _vm.searchTerm = $$v
            },
            expression: "searchTerm",
          },
        }),
        _vm._v(" "),
        _c("b-form-input", {
          staticClass: "transparent-input shx-th-200",
          attrs: {
            type: "search",
            debounce: "400",
            placeholder: "Years (e.g. 2024,2025)",
          },
          model: {
            value: _vm.years,
            callback: function ($$v) {
              _vm.years = $$v
            },
            expression: "years",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        { class: "box-content pt-3" + (_vm.results.length ? "" : " d-none") },
        [
          _c("b-table", {
            staticClass: "shx-table w-100",
            attrs: {
              id: "history-search-table",
              hover: "",
              dark: "",
              fixed: "",
              "sort-icon-left": "",
              busy: _vm.fetching,
              fields: _vm.columns,
              items: _vm.results,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "cell(movix_title)",
                fn: function (data) {
                  return [
                    _c(
                      "router-link",
                      { attrs: { to: `/history/${data.item.movix_id}` } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(data.item.movix_title || "—") +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(released_at)",
                fn: function (data) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatDate(data.item.released_at))),
                    ]),
                  ]
                },
              },
              {
                key: "cell(last_admissions_at)",
                fn: function (data) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatDate(data.item.last_admissions_at))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(total_admissions_belgium)",
                fn: function (data) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formatInt(data.item.total_admissions_belgium)
                        )
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(total_admissions_brightfish)",
                fn: function (data) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formatInt(data.item.total_admissions_brightfish)
                        )
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(papayas)",
                fn: function (data) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatInt(data.item.papayas))),
                    ]),
                  ]
                },
              },
              {
                key: "table-busy",
                fn: function () {
                  return [_c("table-spinner")]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.results.length
        ? _c(
            "div",
            { staticClass: "box-content pt-4 text-center text-muted" },
            [_vm._v("\n            " + _vm._s(_vm.emptyMessage) + "\n        ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.results.length && !_vm.fetching && _vm.trimmedTerm
        ? _c("div", { staticClass: "box-content pt-3" }, [
            _vm.isNumericTerm
              ? _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("p", { staticClass: "mb-2 text-muted" }, [
                      _vm._v(
                        "No history yet for Movix #" +
                          _vm._s(_vm.trimmedTerm) +
                          "."
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          disabled: _vm.compilingId !== null,
                        },
                        on: {
                          click: function ($event) {
                            _vm.onCompile(parseInt(_vm.trimmedTerm, 10))
                          },
                        },
                      },
                      [
                        _vm.compilingId !== null
                          ? _c("spinner-bars")
                          : _c("span", [_vm._v("Compile from Movix Calendar")]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm.suggestions.length
              ? _c(
                  "div",
                  [
                    _c("heading", {
                      attrs: { upper: "Found in Movix Calendar", border: "" },
                    }),
                    _vm._v(" "),
                    _c("b-table", {
                      staticClass: "shx-table w-100",
                      attrs: {
                        id: "history-suggestions-table",
                        hover: "",
                        dark: "",
                        fixed: "",
                        fields: _vm.suggestionColumns,
                        items: _vm.suggestions,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "cell(movix_title)",
                            fn: function (data) {
                              return [
                                data.item.already_compiled
                                  ? _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: `/history/${data.item.movix_id}`,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(data.item.movix_title) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(data.item.movix_title)),
                                    ]),
                              ]
                            },
                          },
                          {
                            key: "cell(released_at)",
                            fn: function (data) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(data.item.released_at)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "cell(imdb_id)",
                            fn: function (data) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(data.item.imdb_id || "—")),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                data.item.already_compiled
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "btn btn-sm btn-outline-secondary",
                                        attrs: {
                                          to: `/history/${data.item.movix_id}`,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            View →\n                        "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "primary",
                                          disabled: _vm.compilingId !== null,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onCompile(
                                              data.item.movix_id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.compilingId === data.item.movix_id
                                          ? _c("spinner-bars")
                                          : _c("span", [_vm._v("Compile")]),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        907800179
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }